import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { removeInspectionServiceImage } from '../../api/inspection-service.ts';
import { RemoveInspectionServiceImageRequest } from '../../api/requests/inspection-service-request.ts';

export default function useRemoveInspectionServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof removeInspectionServiceImage>>,
  Error,
  RemoveInspectionServiceImageRequest
> {
  return useMutation({
    mutationFn: removeInspectionServiceImage,
  });
}
